const parseKeys = (head, translations = {}) =>
  head.split(/\s+/).map((key) => translations[key] || key);

const serviceName = (value) =>
  value === 'IPOTHER-ALL'
    ? "IPOther-All"
    : value.slice(0, 5) + value.slice(5).toLowerCase();

const intoObject = (keys, skipped) => (row) =>
  Object.fromEntries(
    row
      .trim()
      .split(/\s+/)
      .flatMap((value, index) =>
        skipped.includes(keys[index])
          ? []
          : [[keys[index], index === 0 ? serviceName(value) : Number(value)]]
      )
  );

export const parseStateActiveSessions = (input) => {
  const [head, ...rows] = input.length === 0 ? [] : input.trim().split("\n");
  const translations = {
    STATE: "name",
    CREATED: "created",
    DELETED: "deleted",
    ACTIVE: "active",
  };
  const keys = parseKeys(head, translations);
  const skipped = ["created", "deleted"];
  return { connections: rows.map(intoObject(keys, skipped)) };
};
